const baseUrl = "https://report-alforest.ru:8100"
export default baseUrl;